import { createContext, useContext } from 'react';
import { MenuParentContext } from './menu.model';

export const MenuGroupContext = createContext<MenuParentContext | null>(null);
MenuGroupContext.displayName = 'MenuGroupContext';
export const useMenuGroupContext = () => useContext(MenuGroupContext);
